import React, { useContext, useEffect, useState } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { getContext } from "../../../Helpers/Context/Context";
import { useLocation, useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import InputForm from "../../../Components/InputForm/InputForm";
import { Box, TextField, Typography } from "@mui/material";
import {
  getCurreny,
  getCustomers,
  getEngagements,
  InsertIntoPurchaseOrderMaster,
  PurchaseOrderFormGirdDataById,
  DeletePoFormMilestone,
  FileDownload,
  getMonthAndExpiry,

} from "../../../Helpers/API/APIEndPoints";
import { APICall } from "../../../Helpers/API/APICalls";
import moment from "moment";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { LoaderContext } from "../../../Helpers/Context/Context";
import notify from "../../../Helpers/ToastNotification";
// import Modal from "@mui/material/Modal";
import { Modal } from "react-bootstrap";
import { APICalls } from "../../../Helpers/API/APICalls2";
import axios from "axios";
import fileDownload from "js-file-download";
import { Tooltip } from "antd";

interface LocationState {
  id: number;
}

// created by Prashant
const PurchaseOrderFormEdit = () => {
  const [fetchedData, setFetchedData] = useState<any>(null);
  const { EmployeeId, RoleId } = getContext();
  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [customerSelectData, setCustomerSelectData] = useState<any>({});
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [selectedEngagement, setSelectedEngagement] = useState<any>({});
  const [POCurrencyOptions, setPOCurrencyOptions] = useState<any>([]);
  const [POCurrencySelectData, setPOCurrencySelectData] = useState({
    value: 1,
    label: "INR",
  }); // useState<any>({});
  const [FormErrors, setFormErrors] = useState<any>({});
  const [POReceivedDate, setPOReceivedDate] = useState<any>(null); //(new Date());
  const [PONumber, setPONumber] = useState("");
  const [PODate, setPODate] = useState<any>(null); //useState<Date | null>(null);
  const [POValue, setPOValue] = useState("");
  const [InrConvertRate, setInrConvertRate] = useState<any>();
  const [InrAmount, setInrAmount] = useState<any>();
  const [POSubject, setPOSubject] = useState("");
  const [PaymentTerm, setPaymentTerm] = useState("");
  const [DispatchTo, setDispatchTo] = useState("");
  const [Attn, setAttn] = useState("");
  const [GSTNo, setGSTNo] = useState("");
  const [FileName, setFileName] = useState<any>("No File Uploaded");
  const [POFile, setPOFile] = useState<any>();
  const [MilestonePercentage, setMilestonePercentage] = useState("");
  const [Milestone, setMilestone] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [IsActives, setIsActives] = useState(true);
  const [gridData, setGridData] = useState([]);
  const [PurchaseOrderId, setPurchaseOrderId] = useState("");
  const [POSharePointLinkId, setPOSharePointLinkId] = useState("");
  const [SharePointLink, setSharePointLink] = useState("");
  const [POFormMilestoneId, setPOFormMilestoneId] = useState("");
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [deleteMilestone, setDeleteMilestone] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState(0);
  const [MilestoneArray, setMilestoneArray] = useState([]);
  const [showCheckbox, setShowCheckbox] = useState(false);
  const location = useLocation();
  const [add, setAdd] = useState("");
  const [formData, setFormData] = useState(new FormData());
  const [formData2, setFormData2] = useState(new FormData());
  const [errorMsg, setErrorMsg] = useState("");
  const [poExpiryDate, setPoExpiryDate] = useState<any>(null);
  const [poMonths, setPoMonths] = useState<any>(null);
  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );
  const state = location.state as LocationState;

  let navigate = useNavigate();
  let poFormMilestoneId;

  useEffect(() => {
    if (
      selectedEngagement &&
      (selectedEngagement.description == 1 ||
        selectedEngagement.description == 4)
    ) {
      getMonthAndExpiryDate();
    } else {
      setPoMonths(null);
      setPoExpiryDate(null);
    }
  }, [selectedEngagement]);

  const getMonthAndExpiryDate = async () => {
    let obj = {
      EngagementId: selectedEngagement.value,
    };
   // console.log("request obj=>", obj);
    const { data } = await APICall(getMonthAndExpiry, "POST", obj);
   // console.log("month and expiryDate==>", data);
    if (data != null) {
      setPoMonths(data.poMonths);
      setPoExpiryDate(data.poExpiryDate);
    }
  };

  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    bgcolor: "background.paper",

    boxShadow: 24,
    p: 4,
  };

  const handleAddData = (newItem) => {
    if (Array.isArray(newItem)) {
      setMilestoneArray([...newItem]);
    } else {
      setMilestoneArray((prevArray) => [...prevArray, newItem]);
    }

    setGridData((prevData) => {
      if (isEditing) {
        const updatedData = [...prevData];
        updatedData[editIndex] = newItem;
        setIsEditing(false);
        setEditIndex(null);

        return updatedData;
      } else {
        return [...prevData, newItem];
      }
    });
  };
  const handleOpen = async (milestone) => {
    setDeleteMilestone(milestone);
    setMilestoneArray((prevArray) =>
      prevArray.filter((item) => item !== milestone)
    );
    setIsActives(false);
    setOpen(true);
  };

  const removeMilestone = async (poFormMilestoneId) => {
    setGridData((prevData) => {
      return prevData.filter((item) => item !== deleteMilestone);
    });
    setOpen(false);
    await deleteData(poFormMilestoneId);
  };

  const handleEdit = (milestone, index) => {
    setMilestone(milestone.milestone);
    setMilestonePercentage(milestone.milestonePercentage);
    setPOFormMilestoneId(milestone.poFormMilestoneId);
    setIsEditing(true);
    setEditIndex(index);
    setMilestoneArray((prevArray) =>
      prevArray.filter((item) => item !== milestone)
    );
  };

  const options = {
    selectableRows: "none",
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3", "#e74c3c"];

  const gridColumns = [
    {
      name: "pOFormMilestoneId",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "milestone",
      label: "Milestone",
    },
    {
      name: "milestonePercentage",
      label: "Percentage %",
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let milestone = tableMeta.tableData[tableMeta.rowIndex];
          poFormMilestoneId = milestone.poFormMilestoneId;
          let totalAmt = milestone.milestonePercentage;

          let index = tableMeta.rowIndex;

          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    handleEdit(milestone, index);
                    setCounts(counts + 1);
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
              <Tooltip title="Delete" color={customColors[1]}>
                <a
                  className="action_icon"
                  onClick={async () => {
                    await handleOpen(milestone);

                    //await deleteData(poFormMilestoneId);
                  }}
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  useEffect(() => {
    (async () => {
      if (state == null) {
        setPOReceivedDate(new Date());
      }
      if (state != null) {
        setShowCheckbox(true);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await getCustomer();
      await getCurrency();
    })();
  }, [customerSelectData]);

  useEffect(() => {
    if (Object.keys(customerSelectData).length !== 0) {
      (async () => {
        await getEngagement();
      })();
    }
  }, [customerSelectData]);

  useEffect(() => {
    if (POValue && InrConvertRate) {
      setInrAmount((Number(POValue) * Number(InrConvertRate)).toFixed(2));
    } else {
      setInrAmount("");
    }
  }, [POValue, InrConvertRate]);

  useEffect(() => {
    if (POCurrencySelectData && POCurrencySelectData.value == 1) {
      setInrConvertRate("1");
    } else {
      setInrConvertRate("");
    }
  }, [POCurrencySelectData]);

  const deleteData = async (id) => {
    showLoader();
    const obj = {
      POFormMilestoneId: id ? id : null,
    };

    const { data } = await APICall(DeletePoFormMilestone, "POST", obj);

    hideLoader();
  };

  const getEngagement = async () => {
    const obj = {
      CustomerId: String(customerSelectData.value),
    };

    const { data } = await APICall(getEngagements, "POST", obj);

    if (data != undefined || data != null) {
      let tempArray = [];
      await data.map((d: any) => {
        let tempObj = {
          label: d.engagement,
          value: d.id,
          description: d.engagementType,
        };
        tempArray.push(tempObj);
      });
      setEngagementOptions(tempArray);
    }
  };

  const getCustomer = async () => {
    let obj = {};
    if (RoleId.includes(3)) {
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 3,
      };
    } else if (RoleId.includes(8)) {
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 8,
      };
    } else if (RoleId.includes(2)) {
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 2,
      };
    } else if (RoleId.includes(7)) {
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 7,
      };
    }

    const { data } = await APICall(getCustomers, "POST", obj);

    if (data != undefined || data != null) {
      let customerArray = [];
      await data.map((customer: any) => {
        let tempObj = {
          value: customer.id,
          label: customer.customer,
        };
        customerArray.push(tempObj);
      });
      setCustomerOptions(customerArray);
    }
  };

  const getCurrency = async () => {
    const obj = {};

    const { data } = await APICall(getCurreny, "POST", obj);

    if (data != undefined || data != null) {
      let currencyArray = [];
      await data.map((currency: any) => {
        let tempObj = {
          value: currency.id,
          label: currency.currency,
        };
        currencyArray.push(tempObj);
      });
      setPOCurrencyOptions(currencyArray);
    }
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "PONo") {
      setPONumber(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poNo_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poNo_isEmpty"]: "PO No can not be empty",
        }));
      }
    }

    if (apiFieldName === "poValue") {
      setPOValue(event.target.value);

      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poValue_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poValue_isEmpty"]: "PO Value can not be empty",
        }));
      }
    }
    if (
      selectedEngagement.description == 1 ||
      selectedEngagement.description == 4
    ) {
      if (apiFieldName === "poMonths") {
       // console.log("before result");
        let result = event.target.value;

       // console.log("result==>", result);
        setPoMonths(result);

        if (
          event.target.value &&
          event.target.value !== "" &&
          event.target.value.toString().trim() !== ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["poMonths_isEmpty"]: undefined,
          }));
        } else if (
          !event.target.value ||
          event.target.value === "" ||
          event.target.value.toString().trim() === ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["poMonths_isEmpty"]: "PO Month can not be empty",
          }));
        }
      }
    }

    if (apiFieldName === "INRConvertRate") {
      setInrConvertRate(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["INRConvertRate_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["INRConvertRate_isEmpty"]: "INR Convertion Rate can not be empty",
        }));
      }
    }

    if (apiFieldName === "INRAmount") {
      setInrAmount(event.target.value);
      // if (
      //   event.target.value &&
      //   event.target.value !== "" &&
      //   event.target.value.toString().trim() !== ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["INRAmount_isEmpty"]: undefined,
      //   }));
      // } else if (
      //   !event.target.value ||
      //   event.target.value === "" ||
      //   event.target.value.toString().trim() === ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["INRAmount_isEmpty"]: "INR Amount can not be empty",
      //   }));
      // }
    }

    if (apiFieldName === "poSubject") {
      setPOSubject(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poSubject_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poSubject_isEmpty"]: "PO Subject can not be empty",
        }));
      }
    }

    if (apiFieldName === "paymentTerm") {
      setPaymentTerm(event.target.value);

      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["paymentTerm_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["paymentTerm_isEmpty"]: "Payment Term can not be empty",
        }));
      }
    }

    if (apiFieldName === "dispatchTo") {
      setDispatchTo(event.target.value);
      // if (
      //   event.target.value &&
      //   event.target.value !== "" &&
      //   event.target.value.toString().trim() !== ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["dispatchTo_isEmpty"]: undefined,
      //   }));
      // } else if (
      //   !event.target.value ||
      //   event.target.value === "" ||
      //   event.target.value.toString().trim() === ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["dispatchTo_isEmpty"]: "Dispatch To can not be empty",
      //   }));
      // }
    }

    if (apiFieldName === "attn") {
      setAttn(event.target.value);
      // if (
      //   event.target.value &&
      //   event.target.value !== "" &&
      //   event.target.value.toString().trim() !== ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["attn_isEmpty"]: undefined,
      //   }));
      // } else if (
      //   !event.target.value ||
      //   event.target.value === "" ||
      //   event.target.value.toString().trim() === ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["attn_isEmpty"]: "Attn can not be empty",
      //   }));
      // }
    }

    if (apiFieldName === "gstNo") {
      setGSTNo(event.target.value);
      // if (
      //   event.target.value &&
      //   event.target.value !== "" &&
      //   event.target.value.toString().trim() !== ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["gstNo_isEmpty"]: undefined,
      //   }));
      // } else if (
      //   !event.target.value ||
      //   event.target.value === "" ||
      //   event.target.value.toString().trim() === ""
      // ) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["gstNo_isEmpty"]: "GST No can not be empty",
      //   }));
      // }
    }

    if (selectedEngagement.description == 3) {
      if (apiFieldName === "Milestone") {
        setMilestone(event.target.value);

        if (
          event.target.value &&
          event.target.value !== "" &&
          event.target.value.toString().trim() !== ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["Milestone_isEmpty"]: undefined,
          }));
        } else if (
          !event.target.value ||
          event.target.value === "" ||
          event.target.value.toString().trim() === ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["Milestone_isEmpty"]: "Milestone can not be empty",
          }));
        }
      }

      if (apiFieldName === "MilestonePercentage") {
        setMilestonePercentage(event.target.value);

        if (
          event.target.value &&
          event.target.value !== "" &&
          event.target.value.toString().trim() !== ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["MilestonePercentage_isEmpty"]: undefined,
          }));
        } else if (
          !event.target.value ||
          event.target.value === "" ||
          event.target.value.toString().trim() === ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["MilestonePercentage_isEmpty"]:
              "Milestone Percentage can not be empty",
          }));
        }
      }
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "customer") {
      setCustomerSelectData(event);
      setSelectedEngagement({});

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["customer_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["customer_isEmpty"]: "Customer can not be empty",
        }));
      }
    }

    if (apiFieldName === "engagement") {
      setSelectedEngagement(event);
     // console.log("enaggement event==>", selectedEngagement, "===", event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Enagagement can not be empty",
        }));
      }
    }

    if (apiFieldName === "poReceivedDate") {
      let date = moment(event).format(moment.HTML5_FMT.DATE);
      setPOReceivedDate(date);

      if (date != undefined || date != null) {
        setFormErrors((preState) => ({
          ...preState,
          ["poReceivedDate_isEmpty"]: undefined,
        }));
      } else if (date == undefined || date == null) {
        setFormErrors["poReceivedDate_isEmpty"] =
          "PO Received Date Can Not Be Empty";
      }
    }

    if (apiFieldName === "PODate") {
      let dates = moment(event).format(moment.HTML5_FMT.DATE);
      setPODate(dates);

      if (dates && Object.keys(dates).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poDate_isEmpty"]: undefined,
        }));
      } else if (!dates || Object.keys(dates).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poDate_isEmpty"]: "PO Date can not be empty",
        }));
      }
    }

    if (
      selectedEngagement.description == 1 ||
      selectedEngagement.description == 4
    ) {
      if (apiFieldName === "poExpiryDate") {
        let dates = moment(event).format(moment.HTML5_FMT.DATE);
        setPoExpiryDate(dates);

        if (dates && Object.keys(dates).length > 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["poExpiryDate_isEmpty"]: undefined,
          }));
        } else if (!dates || Object.keys(dates).length === 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["poExpiryDate_isEmpty"]: "PO Expiry Date can not be empty",
          }));
        }
      }
    }

    if (apiFieldName === "POCurrency") {
      setPOCurrencySelectData(event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poCurrency_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poCurrency_isEmpty"]: "PO Currency can not be empty",
        }));
      }
    }
  };

  const handleFiles = (e: any, apiFieldName) => {
    const file = e.target.files[0];

    if (!file || file === "" || file.toString().trim() === "") {
      setFormErrors((prevState) => ({
        ...prevState,
        ["poFile_isEmpty"]: "Please upload PO",
      }));
    } else {
      setFormErrors((prevState) => ({
        ...prevState,
        ["poFile_isEmpty"]: undefined,
      }));
    }

    if (file) {
      if (
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        setFileName(file.name);
        setPOFile(file);
        setErrorMsg("");
      } else {
        setErrorMsg(
          "The selected file is not a PDF, DOC, or DOCX. Please upload a valid file."
        );
        setFileName("");
        setPOFile(null);
      }
    }

    // if(file.type === 'application/pdf' || file.type === 'application/msword' ||
    //     file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){

    //   setFileName(file.name);
    //   setPOFile(file);
    //   setErrorMsg('');
    // }
    // else{

    //   setErrorMsg('The selected file is not a PDF, DOC, or DOCX. Please upload a valid file.');
    //   setFileName('');
    //   setPOFile(null);
    // }
  };

  const resetFunc = () => {
    setCustomerOptions([]);
    setCustomerSelectData({});
    setEngagementOptions([]);
    setSelectedEngagement({});
    setPOCurrencyOptions([]);
    setPOCurrencySelectData({ value: 1, label: "INR" });
    setFormErrors({});
    setPOReceivedDate(null);
    setPONumber("");
    setPODate(null);
    setPOValue("");
    setInrAmount("");
    setInrConvertRate("");
    setPOSubject("");
    setPaymentTerm("");
    setDispatchTo("");
    setAttn("");
    setGSTNo("");
    setFileName("No File Uploaded");
    setPOFile({});
    setMilestonePercentage("");
    setMilestone("");
    setIsActive(null);
    setGridData([]);
    setPurchaseOrderId("");
    setPOSharePointLinkId("");
    setPOFormMilestoneId("");
    setMilestoneArray([]);
    setErrorMsg("");
  };

  const onSubmitValidation = async () => {
    await setFormErrors({});
    //formErrorObj = {};
    if (
      selectedEngagement.label == null ||
      !selectedEngagement ||
      Object.keys(selectedEngagement).length === 0
    ) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagement_isEmpty"]: "Engagement cannot be empty",
      }));
      FormErrors["engagement_isEmpty"] = "Engagement cannot be empty";
    }
    if (
      customerSelectData.value == null ||
      !customerSelectData ||
      Object.keys(customerSelectData).length === 0
    ) {
      setFormErrors((preState) => ({
        ...preState,
        ["customer_isEmpty"]: "Customer cannot be empty",
      }));
      FormErrors["customer_isEmpty"] = "Customer cannot be empty";
    }

    if (!POReceivedDate) {
      setFormErrors((preState) => ({
        ...preState,
        ["poReceivedDate_isEmpty"]: "PO Received Date cannot be empty",
      }));
      FormErrors["poReceivedDate_isEmpty"] = "PO Received Date cannot be empty";
    }

    if (!PONumber || Object.keys(PONumber).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["poNo_isEmpty"]: "PO No cannot be empty",
      }));
      FormErrors["poNo_isEmpty"] = "PO No cannot be empty";
    }

    if (!PODate || Object.keys(PODate).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["poDate_isEmpty"]: "PO Date cannot be empty",
      }));
      FormErrors["poDate_isEmpty"] = "PO Date cannot be empty";
    }

    if (
      selectedEngagement.description == 1 ||
      selectedEngagement.description == 4
    ) {
      if (!poExpiryDate || Object.keys(poExpiryDate).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poExpiryDate_isEmpty"]: "PO Expiry Date cannot be empty",
        }));
        FormErrors["poExpiryDate_isEmpty"] = "PO Expiry Date cannot be empty";
      }

      if (!poMonths) {
        setFormErrors((preState) => ({
          ...preState,
          ["poMonths_isEmpty"]: "PO Month cannot be empty",
        }));
        FormErrors["poMonths_isEmpty"] = "PO Month cannot be empty";
      }
    }

    if (!POValue) {
      setFormErrors((preState) => ({
        ...preState,
        ["poValue_isEmpty"]: "PO Value cannot be empty",
      }));
      FormErrors["poValue_isEmpty"] = "PO Value cannot be empty";
    }
    //Prashant 26-11-2024
    if (!POFile) {
      setFormErrors((preState) => ({
        ...preState,
        ["poFile_isEmpty"]: "Please upload PO",
      }));
      FormErrors["poFile_isEmpty"] = "Please upload PO";
    }

    if (!InrConvertRate) {
      setFormErrors((preState) => ({
        ...preState,
        ["INRConvertRate_isEmpty"]: "INR Convertion Rate cannot be empty",
      }));
      FormErrors["INRConvertRate_isEmpty"] =
        "INR Convertion Rate cannot be empty";
    }

    // if (!InrAmount) {
    //   setFormErrors((preState) => ({
    //     ...preState,
    //     ["INRAmount_isEmpty"]: "INR Amount cannot be empty",
    //   }));
    //   FormErrors["INRAmount_isEmpty"] = "INR Amount cannot be empty";
    // }

    if (
      !POCurrencySelectData ||
      Object.keys(POCurrencySelectData).length === 0
    ) {
      setFormErrors((preState) => ({
        ...preState,
        ["poCurrency_isEmpty"]: "PO Currency cannot be empty",
      }));
      FormErrors["poCurrency_isEmpty"] = "PO Currency cannot be empty";
    }

    if (!POSubject || Object.keys(POSubject).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["poSubject_isEmpty"]: "PO Subject cannot be empty",
      }));
      FormErrors["poSubject_isEmpty"] = "PO Subject cannot be empty";
    }

    if (!PaymentTerm) {
      setFormErrors((preState) => ({
        ...preState,
        ["paymentTerm_isEmpty"]: "Payment Term cannot be empty",
      }));
      FormErrors["paymentTerm_isEmpty"] = "Payment Term cannot be empty";
    }

    // if (!DispatchTo || Object.keys(DispatchTo).length === 0) {
    //   setFormErrors((preState) => ({
    //     ...preState,
    //     ["dispatchTo_isEmpty"]: "Dispatch To cannot be empty",
    //   }));
    //   FormErrors["dispatchTo_isEmpty"] = "Dispatch To cannot be empty";
    // }

    // if (!Attn || Object.keys(Attn).length === 0) {
    //   setFormErrors((preState) => ({
    //     ...preState,
    //     ["attn_isEmpty"]: "Attn cannot be empty",
    //   }));
    //   FormErrors["attn_isEmpty"] = "Attn cannot be empty";
    // }

    // if (!GSTNo || Object.keys(GSTNo).length === 0) {
    //   setFormErrors((preState) => ({
    //     ...preState,
    //     ["gstNo_isEmpty"]: "GSTNo cannot be empty",
    //   }));
    //   FormErrors["gstNo_isEmpty"] = "GSTNo cannot be empty";
    // }

    // if (Object.keys(errorMsg).length === 0 || ) {

    //  }

    if (selectedEngagement.description == 3 && MilestoneArray.length == 0) {
      if (!Milestone) {
        setFormErrors((preState) => ({
          ...preState,
          ["Milestone_isEmpty"]: "Milestone cannot be empty",
        }));

        FormErrors["Milestone_isEmpty"] = "Milestone cannot be empty";
      }

      if (!MilestonePercentage) {
        setFormErrors((preState) => ({
          ...preState,
          ["MilestonePercentage_isEmpty"]:
            "Milestone Percentage cannot be empty",
        }));
        FormErrors["MilestonePercentage_isEmpty"] =
          "Milestone Percentage cannot be empty";
      }
    }
  };

  useEffect(() => {
    GetPurchaseOrderFormDataById();
  }, [state]);

  const OnAddValidation = async () => {
    let isEmpty = false;

    if (!Milestone) {
      setFormErrors((preState) => ({
        ...preState,
        ["Milestone_isEmpty"]: "Milestone cannot be empty",
      }));
      FormErrors["Milestone_isEmpty"] = "Milestone cannot be empty";
      isEmpty = true;
    }

    if (!MilestonePercentage) {
      setFormErrors((preState) => ({
        ...preState,
        ["MilestonePercentage_isEmpty"]: "Milestone Percentage cannot be empty",
      }));
      FormErrors["MilestonePercentage_isEmpty"] =
        "Milestone Percentage cannot be empty";
      isEmpty = true;
    }

    return isEmpty;
  };

  const milestonePercentageCalculationOnSubmit = async () => {
    let total = 0;

    const sumOfPercentages = MilestoneArray.reduce(
      (total, item) => total + Number(item.milestonePercentage),
      0
    );
    total = Number(sumOfPercentages) + total;

    return total;
  };

  const milestonePercentageCalculationOnAdd = async () => {
    let total;

    const newPercentage = Number(MilestonePercentage);
    const sumOfPercentages = MilestoneArray.reduce(
      (total, item) => total + Number(item.milestonePercentage),
      0
    );
    total = Number(sumOfPercentages) + newPercentage;

    return total;
  };

  const onClickFunction = async (event: any, apiFieldName: any) => {
    if (apiFieldName == "reset") {
      showLoader();
      await resetFunc();
      hideLoader();
    }

    if (apiFieldName == "add") {
      if ((await OnAddValidation()) == false) {
        if ((await milestonePercentageCalculationOnAdd()) <= 100) {
          const newData = {
            milestone: Milestone,
            milestonePercentage: MilestonePercentage,
            poFormMilestoneId:
              counts == 0
                ? null
                : POFormMilestoneId && POFormMilestoneId
                ? POFormMilestoneId
                : null,
            isActives: IsActives,
          };

          handleAddData(newData);
          setMilestone("");
          setMilestonePercentage("");
        } else {
          notify(
            1,
            "Total of All the Milestones Percentage should be less than or equal to 100"
          );
        }
      }
    }

    if (apiFieldName == "submit") {
      showLoader();
      event.preventDefault();
      await onSubmitValidation();
      const isEmpty = await Object.values(FormErrors).every(
        (x) => x === null || x === "" || x == undefined
      );
      if (isEmpty) {
       // console.log("inside if");
        const formattedDate = new Date(POReceivedDate).toISOString();
        const newFormData = new FormData();
        const newFormData2 = new FormData();

        // formData.append('CustomerId', String(customerSelectData.value));
        // formData.append('EngagementId', selectedEngagement.value);
        // formData.append('POReceivedDate', formattedDate);
        // formData.append('PONumber', PONumber);
        // formData.append('PODate', PODate);
        // formData.append('POValue', POValue);
        // formData.append('INRConvertRate', InrConvertRate);
        // formData.append('INRAmount', InrAmount);
        // formData.append('CurrencyId', String(POCurrencySelectData.value));
        // formData.append('POSubject', POSubject);
        // formData.append('PaymentTerm', PaymentTerm);
        // formData.append('DispatchTo', DispatchTo);
        // formData.append('Attn', Attn);
        // formData.append('GSTNo', GSTNo);
        // formData.append('EmpId', String(EmployeeId));
        // formData.append('PurchaseOrderId', PurchaseOrderId ? PurchaseOrderId : '');
        // formData.append('POSharePointLinkId', POSharePointLinkId ? POSharePointLinkId : '');
        // formData.append('SharePointLink', SharePointLink ? SharePointLink : '' );
        // formData.append('IsActive', isActive ? 'true' : 'false');
        // formData.append('file', POFile); // Assuming POFile is a File object

        //added by mahesh on 14/10/2024
        newFormData.append("CustomerId", String(customerSelectData.value));
        newFormData.append("EngagementId", selectedEngagement.value);
        newFormData.append("POReceivedDate", formattedDate);
        newFormData.append("PONumber", PONumber);
        newFormData.append("PODate", PODate);
        newFormData.append("POValue", POValue);
        newFormData.append("INRConvertRate", InrConvertRate);
        newFormData.append("INRAmount", InrAmount);
        newFormData.append("CurrencyId", String(POCurrencySelectData.value));
        newFormData.append("POSubject", POSubject);
        newFormData.append("PaymentTerm", PaymentTerm);
        newFormData.append("DispatchTo", DispatchTo);
        newFormData.append("Attn", Attn);
        newFormData.append("GSTNo", GSTNo);
        newFormData.append("EmpId", String(EmployeeId));
        newFormData.append(
          "PurchaseOrderId",
          PurchaseOrderId ? PurchaseOrderId : ""
        );
        newFormData.append(
          "POSharePointLinkId",
          POSharePointLinkId ? POSharePointLinkId : ""
        );
        newFormData.append(
          "SharePointLink",
          SharePointLink ? SharePointLink : ""
        );
        newFormData.append("IsActive", isActive ? "true" : "false");
        newFormData.append(
          "PoMonths",
          selectedEngagement.description == 1 ||
            selectedEngagement.description == 4
            ? poMonths
            : 0
        );
        newFormData.append(
          "PoExpiryDate",
          selectedEngagement.description == 1 ||
            selectedEngagement.description == 4
            ? poExpiryDate
            : ""
        );
        newFormData.append("file", POFile); // Assuming POFile is a File object

        //end by mahesh

        setFormData(formData);

        newFormData2.append("CustomerId", String(customerSelectData.value));
        newFormData2.append("POReceivedDate", formattedDate);
        newFormData2.append("EngagementId", selectedEngagement.value);
        newFormData2.append("PONumber", PONumber);
        newFormData2.append("PODate", PODate);
        newFormData2.append("POValue", POValue);
        newFormData2.append("INRConvertRate", InrConvertRate);
        newFormData2.append("INRAmount", InrAmount);
        newFormData2.append("CurrencyId", String(POCurrencySelectData.value));
        newFormData2.append("POSubject", POSubject);
        newFormData2.append("PaymentTerm", PaymentTerm);
        newFormData2.append("DispatchTo", DispatchTo);
        newFormData2.append("Attn", Attn);
        newFormData2.append("GSTNo", GSTNo);
        newFormData2.append("EmpId", String(EmployeeId));
        newFormData2.append(
          "PurchaseOrderId",
          PurchaseOrderId ? PurchaseOrderId : ""
        );
        newFormData2.append(
          "POSharePointLinkId",
          POSharePointLinkId ? POSharePointLinkId : ""
        );
        newFormData2.append(
          "SharePointLink",
          SharePointLink ? SharePointLink : ""
        );
        newFormData2.append("IsActive", isActive ? "true" : "false");
        newFormData2.append("file", POFile);
        //newFormData2.append('PoMonths',poMonths);
        //newFormData2.append('PoExpiryDate',poExpiryDate);
        // formData2.append('Milestone' , Milestone);
        // formData2.append('MilestonePercentage' , MilestonePercentage);
        newFormData2.append("MilestoneArrays", JSON.stringify(MilestoneArray));
        newFormData2.append(
          "EngagementType",
          selectedEngagement && selectedEngagement.description
            ? selectedEngagement.description
            : null
        );

        setFormData2(formData2);
        // const reqparam = {
        //   CustomerId: String(customerSelectData.value),
        //   EngagementId: selectedEngagement.value,
        //   POReceivedDate: POReceivedDate,
        //   PONumber: PONumber,
        //   PODate: PODate,
        //   POValue: POValue,
        //   INRConvertRate: InrConvertRate,
        //   INRAmount: InrAmount,
        //   CurrencyId: POCurrencySelectData.value,
        //   POSubject: POSubject,
        //   PaymentTerm: PaymentTerm,
        //   DispatchTo: DispatchTo,
        //   Attn: Attn,
        //   GSTNo: GSTNo,
        //   // fileData : fileData,
        //   // FileName : FileName,
        //   //file : POFile,
        //   EmpId: Number(EmployeeId),
        //   PurchaseOrderId: PurchaseOrderId ? PurchaseOrderId : null,
        //   IsActive: isActive,
        // };

        // const reqparam2 = {
        //   CustomerId: String(customerSelectData.value),
        //   EngagementId: selectedEngagement.value,
        //   POReceivedDate: POReceivedDate,
        //   PONumber: PONumber,
        //   PODate: PODate,
        //   POValue: POValue,
        //   INRConvertRate: InrConvertRate,
        //   INRAmount: InrAmount,
        //   CurrencyId: POCurrencySelectData.value,
        //   POSubject: POSubject,
        //   PaymentTerm: PaymentTerm,
        //   DispatchTo: DispatchTo,
        //   Attn: Attn,
        //   GSTNo: GSTNo,
        //   //FileName : FileName,
        //   poFile : POFile,
        //   EmpId: Number(EmployeeId),
        //   PurchaseOrderId: PurchaseOrderId ? PurchaseOrderId : null,
        //   IsActive: isActive,
        //   MilestoneArray: MilestoneArray,
        //   // POFormMilestoneId : POFormMilestoneId,
        //   // Milestone : Milestone,
        //   // MilestonePercentage : MilestonePercentage,
        //   EngagementType:
        //     selectedEngagement && selectedEngagement.description
        //       ? selectedEngagement.description
        //       : null,
        // };

        if (selectedEngagement.description == 3) {
          //project
          if ((await milestonePercentageCalculationOnSubmit()) == 100) {
           // console.log("formdata2", newFormData2);
            const { data } = await APICalls(
              InsertIntoPurchaseOrderMaster,
              "POST",
              newFormData2
              // formData2
            );

            hideLoader();

            if (data == "Data Saved Successfully") {
              showLoader();

              setTimeout(() => {
                resetFunc();
                navigate(-1);
                notify(0, data);
              }, 5000);
            } else if (
              data == "Data has been saved but Error Occured during PO Upload"
            ) {
              showLoader();

              setTimeout(() => {
                resetFunc();
                navigate(-1);
                notify(0, data);
              }, 5000);
            } else if (
              data == "Data has been saved and PO Uploaded successfully"
            ) {
              showLoader();

              setTimeout(() => {
                resetFunc();
                navigate(-1);
                notify(0, data);
              }, 5000);
            } else if (
              data &&
              data ==
                "Functional Owner is not Mapped for the selected Engagement and Data is Inserted, mail is not sent."
            ) {
              notify(1, data);
              navigate(-1);
            } else {
              notify(1, "Data Insertion Failed");
            }
          } else {
            hideLoader();
            notify(1, "Sum of all the Milestone Percentage should be 100%");
          }
        } else {
         // console.log("formdata", newFormData);

          const { data } = await APICalls(
            InsertIntoPurchaseOrderMaster,
            "POST",
            newFormData
            // formData
          );

          hideLoader();

          if (data == "Data Saved Successfully") {
            showLoader();

            setTimeout(() => {
              resetFunc();
              navigate(-1);
              notify(0, data);
            }, 5000);
          } else if (
            data == "Data has been saved but Error Occured during PO Upload"
          ) {
            showLoader();

            setTimeout(() => {
              resetFunc();
              navigate(-1);
              notify(0, data);
            }, 5000);
          } else if (
            data == "Data has been saved and PO Uploaded successfully"
          ) {
            showLoader();

            setTimeout(() => {
              resetFunc();
              navigate(-1);
              notify(0, data);
            }, 5000);
          } else if (
            data &&
            data ==
              "Functional Owner is not Mapped for the selected Engagement and Data is Inserted, mail is not sent."
          ) {
            notify(1, data);
            navigate(-1);
          } else {
            notify(1, "Data Insertion Failed");
          }
        }
      }
      hideLoader();
    }

    if (apiFieldName == "download") {
      let reqparam = {
        FileUrl: SharePointLink,
        Customer: customerSelectData.label,
      };
      let date = moment(PODate).format("YYYY/MMMM/DD"); //moment(PODate).format(moment.HTML5_FMT.DATE);

      axios
        .request({
          responseType: "blob",
          method: "POST",
          url: FileDownload,
          data: reqparam,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers": "*",
          },
        })
        .then((response) => {
          fileDownload(response.data, `${PONumber}-${date}.pdf`);
        })
        .catch((error) => {
          if (error) {
            notify(
              1,
              "File not found or an error occurred during the download."
            );
          }
          console.error(error.response.data);
        });
    }
  };

  const GetPurchaseOrderFormDataById = async () => {
    if (state && state !== null) {
      showLoader();

      let post = {
        PurchaseOrderId: state,
      };
      const { data } = await APICall(
        PurchaseOrderFormGirdDataById,
        "POST",
        post
      );

      if (data.length > 0) {
        const poData = data[0];

        setFetchedData(poData);
        setAttn(data[0].attn ? data[0].attn : "");
        setPONumber(data[0].poNumber ? data[0].poNumber : "");
        setPOValue(data[0].poValue ? data[0].poValue : 0);
        setPOSubject(data[0].poSubject ? data[0].poSubject : "");
        setPaymentTerm(data[0].paymentTerm ? data[0].paymentTerm : 0);
        setDispatchTo(data[0].dispatchTo ? data[0].dispatchTo : "");
        setGSTNo(data[0].gstNo ? data[0].gstNo : "");
        setIsActive(data[0].isActive);
        setPOReceivedDate(data[0].poReceivedDate);
        setPODate(data[0].poDate);
        setPurchaseOrderId(data[0].purchaseOrderId);
        setPOSharePointLinkId(data[0].poSharePointLinkId);
        setSharePointLink(data[0].sharePointLink);
        setCustomerSelectData({
          value: poData.customerId,
          label: poData.customer,
        });
        setSelectedEngagement({
          value: poData.engagementId,
          label: poData.engagement,
          description: poData.engagementType,
        });
        setPOCurrencySelectData(
          poData.currencyId == null
            ? { value: 1, label: "INR" }
            : { value: poData.currencyId, label: poData.currency }
        );
        setInrConvertRate(
          poData.currencyId == 1 || poData.currencyId == null
            ? "1"
            : data[0].inrConvertRate
        );
        setInrAmount(data[0].inrAmount);

        if (poData.engagementType == 3) {
          setGridData(poData.milestoneArray);
          setMilestoneArray(poData.milestoneArray);
        }
      }
      hideLoader();
    }
  };

  useEffect(() => {
    if (fetchedData) {
      // setInrConvertRate(fetchedData.inrConvertRate);
      setInrConvertRate(
        fetchedData.currencyId == 1 || fetchedData.currencyId == null
          ? "1"
          : fetchedData.inrConvertRate
      );
      setInrAmount(
        fetchedData.currencyId == 1 || fetchedData.currencyId == null
          ? (Number(POValue) * Number(InrConvertRate)).toFixed(2)
          : fetchedData.inrAmount
      );
    }
  }, [fetchedData]);

  return (
    <>
      <Heading title={"Purchase Order"} />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Select Customer <sup>*</sup>{" "}
              </label>
              <SelectForm
                options={customerOptions}
                placeholder="Select Customer"
                value={
                  customerSelectData || {
                    value: "",
                    label: "Select Customer",
                  }
                }
                onChange={(event) => selectOnChange(event, "customer")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{FormErrors["customer_isEmpty"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Select Engagement <sup>*</sup>{" "}
              </label>
              <SelectForm
                options={EngagementOptions}
                placeholder="Select Engagement"
                value={selectedEngagement || ""}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{FormErrors["engagement_isEmpty"]}</p>
            </div>
          </div>

          {PurchaseOrderId ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Received Date <sup>*</sup>{" "}
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Received Date"
                      value={POReceivedDate}
                      disabled={false}
                      onChange={(event) =>
                        selectOnChange(event, "poReceivedDate")
                      }
                      // inputFormat="dd/MM/yyyy"
                      // minDate={new Date()}
                      // maxDate= {new Date()}
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                      inputFormat="dd/MM/yyyy"
                      //InputProps={{ placeholder: "dd/MM/yyyy" }}
                      minDate={new Date("1900-01-01")}
                      maxDate={new Date()}
                      disableFuture
                    />
                    <p style={{ color: "red" }}>
                      {FormErrors["poReceivedDate_isEmpty"]}
                    </p>
                  </LocalizationProvider>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Received Date <sup>*</sup>{" "}
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Received Date"
                      value={POReceivedDate}
                      onChange={(event) =>
                        selectOnChange(event, "poReceivedDate")
                      }
                      inputFormat="dd/MM/yyyy"
                      //InputProps={{ placeholder: "dd/MM/yyyy" }}
                      minDate={new Date("1900-01-01")}
                      maxDate={new Date()}
                      disableFuture
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                    <p style={{ color: "red" }}>
                      {FormErrors["poReceivedDate_isEmpty"]}
                    </p>
                  </LocalizationProvider>
                </div>
              </div>
            </>
          )}

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO Date <sup>*</sup>{" "}
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="PO Date"
                  value={PODate}
                  onChange={(event) => selectOnChange(event, "PODate")}
                  inputFormat="dd/MM/yyyy"
                  //maxDate= {new Date()}
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                />
                <p style={{ color: "red" }}>{FormErrors["poDate_isEmpty"]}</p>
              </LocalizationProvider>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO Value <sup>*</sup>
              </label>
              <InputForm
                placeholder={"POValue"}
                isDisabled={false}
                textArea={false}
                value={POValue}
                onChange={(event) => handleTextEvent(event, "poValue")}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <p style={{ color: "red" }}>{FormErrors["poValue_isEmpty"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO Currency <sup>*</sup>{" "}
              </label>
              <SelectForm
                options={POCurrencyOptions}
                placeholder="PO Currency"
                value={POCurrencySelectData || ""}
                onChange={(event) => selectOnChange(event, "POCurrency")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{FormErrors["poCurrency_isEmpty"]}</p>
            </div>
          </div>

          {POCurrencySelectData && POCurrencySelectData.value == 1 ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    INR Convertion Rate <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"INR Convertion Rate"}
                    isDisabled={true}
                    textArea={false}
                    value={InrConvertRate}
                    onChange={(event) =>
                      handleTextEvent(event, "INRConvertRate")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {FormErrors["INRConvertRate_isEmpty"]}
                  </p>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    INR Convertion Rate <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"INR Convertion Rate"}
                    isDisabled={false}
                    textArea={false}
                    value={InrConvertRate}
                    onChange={(event) =>
                      handleTextEvent(event, "INRConvertRate")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {FormErrors["INRConvertRate_isEmpty"]}
                  </p>
                </div>
              </div>
            </>
          )}

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>INR Amount {/*<sup>*</sup> */}</label>
              <InputForm
                placeholder={"INR Convertion Rate * PO Value"}
                isDisabled={true}
                textArea={false}
                value={InrAmount}
                onChange={(event) => handleTextEvent(event, "INRAmount")}
                //className="numRight"
                // type="number"
                // onKeyPress={(event) => {
                //   if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                //     event.preventDefault();
                //   }
                // }}
              />
              {/* <p style={{ color: "red" }}>
                  {FormErrors["INRAmount_isEmpty"]}
                </p> */}
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO NO <sup>*</sup>{" "}
              </label>
              <InputForm
                placeholder={"PO no"}
                isDisabled={false}
                textArea={false}
                value={PONumber}
                onChange={(event) => handleTextEvent(event, "PONo")}
              />
              <p style={{ color: "red" }}>{FormErrors["poNo_isEmpty"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                PO Subject <sup>*</sup>{" "}
              </label>

              <InputForm
                placeholder={"PO Subject"}
                isDisabled={false}
                textArea={true}
                value={POSubject}
                onChange={(event) => handleTextEvent(event, "poSubject")}
              />
              <p style={{ color: "red" }}>{FormErrors["poSubject_isEmpty"]}</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Payment Term <sup>*</sup>
              </label>
              <InputForm
                placeholder={"Payment Term"}
                isDisabled={false}
                textArea={false}
                value={PaymentTerm}
                onChange={(event) => handleTextEvent(event, "paymentTerm")}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <p style={{ color: "red" }}>
                {FormErrors["paymentTerm_isEmpty"]}
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>GST No </label>
              <InputForm
                placeholder={"GST No"}
                isDisabled={false}
                textArea={false}
                value={GSTNo}
                onChange={(event) => handleTextEvent(event, "gstNo")}
              />
              {/* <p style={{ color: "red" }}>{FormErrors["gstNo_isEmpty"]}</p> */}
            </div>
          </div>

          <div className="col-lg-12">
            <div className="form-group">
              <label>Dispatch To </label>

              <InputForm
                placeholder={"Dispatch To"}
                isDisabled={false}
                textArea={true}
                value={DispatchTo}
                rows={4}
                onChange={(event) => handleTextEvent(event, "dispatchTo")}
              />
              {/* <p style={{ color: "red" }}>
                {FormErrors["dispatchTo_isEmpty"]}
              </p> */}
            </div>
          </div>

          <div className="col-lg-12">
            <div className="form-group">
              <label>ATTENTION</label>

              <InputForm
                placeholder={"ATTENTION "}
                isDisabled={false}
                textArea={true}
                value={Attn}
                rows={4}
                onChange={(event) => handleTextEvent(event, "attn")}
              />
              {/* <p style={{ color: "red" }}>{FormErrors["attn_isEmpty"]}</p> */}
            </div>
          </div>

          {selectedEngagement &&
          (selectedEngagement.description == 1 ||
            selectedEngagement.description == 4) ? (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    PO Months <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={""}
                    isDisabled={false}
                    textArea={false}
                    value={poMonths}
                    onChange={(event) => handleTextEvent(event, "poMonths")}
                    className="numRight"
                    type="number"
                    // onKeyPress={(event) => {
                    //   if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    //     event.preventDefault();
                    //   }
                    // }}
                  />
                  <p style={{ color: "red" }}>
                    {FormErrors["poMonths_isEmpty"]}
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    PO Expiry Date <sup>*</sup>{" "}
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="PO Expiry Date"
                      value={poExpiryDate}
                      onChange={(event) =>
                        selectOnChange(event, "poExpiryDate")
                      }
                      inputFormat="dd/MM/yyyy"
                      //maxDate= {new Date()}
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                    <p style={{ color: "red" }}>
                      {FormErrors["poExpiryDate_isEmpty"]}
                    </p>
                  </LocalizationProvider>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}

          <div className="col-lg-12">
            <div className="d-flex gap-2">
              <div className="form-group">
                <label>
                  Upload PO <sup>*</sup>
                </label>
                <div className="input-group">
                  <input
                    type="file"
                    accept=".pdf, .doc, .docx"
                    className="custom-file-input"
                    id="file"
                    aria-describedby="inputGroupFileAddon01"
                    onChange={(e) => {
                      handleFiles(e, "PO Upload");
                    }}
                  />
                  <label
                    className="custom-file-label"
                    htmlFor="inputGroupFile01"
                  >
                    {FileName || "Choose file..."}
                  </label>
                </div>

                <p style={{ color: "red" }}>
                  {errorMsg || FormErrors["poFile_isEmpty"]}
                </p>
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-reset"
                    onClick={() => {
                      setFileName("No File Uploaded");
                      setPOFile(null);
                    }}
                  >
                    Clear
                  </button>
                  {SharePointLink && SharePointLink !== null ? (
                    <>
                      <button
                        className="btn btn-export"
                        onClick={(event) => onClickFunction(event, "download")}
                      >
                        Download
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {showCheckbox && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="isActive" className="mr-2">
                  Is Active
                </label>
                <input
                  id="isActive"
                  type="checkbox"
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="isActive"
                  checked={isActive}
                />
              </div>
            </div>
          )}
        </div>
        {selectedEngagement && selectedEngagement.description == 3 ? (
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Milestone <sup>*</sup>{" "}
                </label>
                <InputForm
                  placeholder={"Milestone"}
                  isDisabled={false}
                  textArea={false}
                  value={Milestone}
                  onChange={(event) => handleTextEvent(event, "Milestone")}
                />
                <p style={{ color: "red" }}>
                  {FormErrors["Milestone_isEmpty"]}
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Milestone Percentage %<sup>*</sup>
                </label>
                <InputForm
                  placeholder={"%"}
                  isDisabled={false}
                  textArea={false}
                  value={MilestonePercentage}
                  onChange={(event) =>
                    handleTextEvent(event, "MilestonePercentage")
                  }
                  className="numRight"
                  type="number"
                  onKeyPress={(event) => {
                    if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                <p style={{ color: "red" }}>
                  {FormErrors["MilestonePercentage_isEmpty"]}
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>&nbsp;</label>
                <div>
                  <button
                    onClick={(event) => onClickFunction(event, "add")}
                    className="btn btn-update"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-12 mt-3">
              {gridData.length > 0 && (
                <DynamicGrid
                  options={options}
                  data={gridData}
                  columns={gridColumns}
                />
              )}
            </div>
            <Modal
              show={open}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              centered
              size="sm"
            >
              <Modal.Body className="text-center delete_body p-4">
                <i className="fa fa-info mb-3"></i>
                <p className="mb-3">Are you sure, you want to delete?</p>
                <div className="d-flex justify-content-center gap-2">
                  <button
                    type="button"
                    onClick={() => handleClose()}
                    className="btn btn-reset"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-delete"
                    onClick={() => {
                      removeMilestone(poFormMilestoneId);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        ) : null}

        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button onClick={() => navigate(-1)} className="btn btn-reset">
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={(event) => onClickFunction(event, "reset")}
                  className="btn btn-reset"
                >
                  Reset
                </button>

                <button
                  onClick={(event) => onClickFunction(event, "submit")}
                  className="btn btn-submit"
                  // disabled={gridData.length === 0}
                  //disabled={disabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseOrderFormEdit;
